import { AutogenLayoutCarrierInformationQuickInfo } from "./autogen/AutogenLayoutCarrierInformationQuickInfo";
import { DataDisplayEvent } from "@mcleod/components";

export class CarrierInformationQuickInfo extends AutogenLayoutCarrierInformationQuickInfo {

    labelP44VendorInfoOnDataDisplay(event: DataDisplayEvent) {
        this.labelP44VendorInfo._element.innerHTML = this.mainDataSource.data[0].get("vendor_info");
    }

    sourceQuoteBillingFreightGroupOnDisplay() {
        const quoteBillingFreightGroup = this.sourceQuoteBillingFreightGroup.data[0];
        const hasDestinationTerminal = !quoteBillingFreightGroup.isNull("dest_terminal_name");

        this.labelType.visible = this.labelContractDescr.visible = !quoteBillingFreightGroup.isNull("contract_type_descr");
        this.labelService.visible = this.labelServiceLevel.visible = false;
        this.panelOriginTerminal.visible = !quoteBillingFreightGroup.isNull("orig_terminal_name");
        this.panelDestinationTerminal.visible = hasDestinationTerminal;
        this.panelTerminalInfo.visible = this.panelOriginTerminal.visible || this.panelDestinationTerminal.visible;
        this.panelOriginTerminal.borderRightColor = hasDestinationTerminal ? "default.lightest" : undefined;
        this.panelOriginTerminal.borderRightWidth = hasDestinationTerminal ? 1 : undefined;
    }
}
